import { render, staticRenderFns } from "./TypeMold.vue?vue&type=template&id=6d4ab642&"
import script from "./TypeMold.vue?vue&type=script&lang=js&"
export * from "./TypeMold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports